import { createFileRoute } from '@tanstack/react-router';

import { AdminPageHeader } from '@/components/admin/admin-page-header';
import { SystemHealthCard } from '@/components/admin/system/system-health-card';

export const Route = createFileRoute('/_authenticated/admin/system')({
  staticData: { title: 'System health' },
  component: AdminSystemPage,
});

function AdminSystemPage(): React.ReactElement {
  return (
    <main>
      <AdminPageHeader
        title="System health"
        description="Redis, queue, and database health (auto-refreshes every 30s)"
      />
      <div className="px-4 py-6 sm:px-8">
        <SystemHealthCard />
      </div>
    </main>
  );
}
